/** External */
import React from "react";
import { Modal, Button } from "@toddle-edu/ds-web";

/** Relative */
import classes from "./ConfirmationModal.scss";

const ConfirmationModal = ({ onClickCancel, onClickSubmit }) => {
  return (
    <Modal height="280px" width="450px" onClose={onClickCancel}>
      <Modal.Header title="Warning"></Modal.Header>

      <Modal.Body>
        Enabling a DP curriculum makes all the DP grades premium. Are you sure
        you want to proceed?
      </Modal.Body>

      <Modal.Footer>
        <div className={classes.footer}>
          <Button
            onClick={onClickCancel}
            _legacy_variant="outlined-subtle"
            variant="neutral"
            type="outlined"
            size="large"
          >
            Cancel
          </Button>

          <Button onClick={onClickSubmit} variant="primary" size="large">
            Yes, enable it
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
